import React from 'react';

/**
 * Shown when /auth/me answers 403 NOT_INVITED: the Microsoft sign-in worked but the
 * account is not on the portal's guest list (LGL domain or pre-provisioned e-mail).
 */
const NotInvited = ({ email, onSignOut }) => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', fontFamily: 'Aptos, Segoe UI, sans-serif', padding: 24 }}>
    <div style={{ maxWidth: 520, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(15,23,42,.08)', overflow: 'hidden' }}>
      <div style={{ background: '#bb0302', color: '#fff', padding: '18px 24px', fontWeight: 700, fontSize: 18 }}>LGL Portal — by invitation</div>
      <div style={{ padding: 24, color: '#0f172a', lineHeight: 1.5 }}>
        <p style={{ marginTop: 0 }}>
          Your Microsoft sign-in worked{email ? <> as <strong>{email}</strong></> : null}, but this address has not been added to the portal.
        </p>
        <p>
          Ask your LGL contact (project manager or Project Controls) to add your e-mail address and give you a role. After that, sign in again with the same account.
        </p>
        <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>
          Nothing was created for this account. If you believe this is a mistake, forward this screen to your LGL contact.
        </p>
        <button type="button" onClick={onSignOut} style={{ background: '#0f172a', color: '#fff', border: 0, borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>
          Sign out
        </button>
      </div>
    </div>
  </div>
);

export default NotInvited;
